import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { ComponentRenderer } from './ComponentRenderer'

interface RowProps {
  component: Component
  locale: LocaleCode
  storeId: string
  apiUrl: string
  style: React.CSSProperties
  cartId?: string | null
  wishlistId?: string | null
  onCartUpdate?: (cartId: string) => void
  onWishlistUpdate?: (wishlistId: string) => void
}

export function Row({ component, locale, storeId, apiUrl, style, cartId, wishlistId, onCartUpdate, onWishlistUpdate }: RowProps) {
  const config = component.config as any
  const gap = config.gap || 16

  const rowStyle: React.CSSProperties = {
    ...style,
    display: 'flex',
    flexDirection: 'row',
    gap: `${gap}px`,
    flexWrap: 'wrap',
  }

  return (
    <div style={rowStyle}>
      {component.children?.map((child) => (
        <ComponentRenderer
          key={child.id}
          component={child}
          locale={locale}
          storeId={storeId}
          apiUrl={apiUrl}
          cartId={cartId}
          wishlistId={wishlistId}
          onCartUpdate={onCartUpdate}
          onWishlistUpdate={onWishlistUpdate}
        />
      ))}
    </div>
  )
}
